import React from 'react';
import { CheckCircle, AlertTriangle, XCircle } from 'lucide-react';

export function ComplianceMetrics() {
  const metrics = [
    {
      name: 'Documentation Compliance',
      status: 'success',
      value: '98%',
      description: 'All required documents properly formatted and submitted',
    },
    {
      name: 'Deadline Adherence',
      status: 'warning',
      value: '92%',
      description: '2 proposals submitted close to deadline',
    },
    {
      name: 'Requirements Coverage',
      status: 'success',
      value: '96%',
      description: 'Technical requirements fully addressed',
    },
    {
      name: 'Past Performance',
      status: 'error',
      value: '85%',
      description: 'Missing performance data for 3 contracts',
    },
  ];

  const getIcon = (status: string) => {
    switch (status) {
      case 'success':
        return <CheckCircle className="h-5 w-5 text-green-500" />;
      case 'warning':
        return <AlertTriangle className="h-5 w-5 text-yellow-500" />;
      case 'error':
        return <XCircle className="h-5 w-5 text-red-500" />;
      default:
        return null;
    }
  };

  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <h3 className="text-lg font-medium text-gray-900">Compliance Metrics</h3>
      <div className="mt-4 space-y-4">
        {metrics.map((metric) => (
          <div key={metric.name} className="flex items-start space-x-3">
            {getIcon(metric.status)}
            <div>
              <div className="flex items-center space-x-2">
                <span className="font-medium text-gray-900">{metric.name}</span>
                <span
                  className={`rounded-full px-2 py-0.5 text-xs font-medium ${
                    metric.status === 'success'
                      ? 'bg-green-100 text-green-800'
                      : metric.status === 'warning'
                      ? 'bg-yellow-100 text-yellow-800'
                      : 'bg-red-100 text-red-800'
                  }`}
                >
                  {metric.value}
                </span>
              </div>
              <p className="mt-0.5 text-sm text-gray-500">{metric.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}